export function hasRenderableArtworkReference(artwork) {
  return Boolean(artwork?.artwork_about);
}

export function hasRenderableArtworkGridItem(artwork) {
  return Boolean(
    artwork?._id
    && artwork?.slug
    && artwork?.artwork_about
    && artwork?.artwork_media?.artwork_main_picture?.image_original_data?.aspect_ratio
  );
}

export function hasRenderableArtlist(artlist) {
  return Boolean(
    artlist?._id
    && (
      typeof artlist?.artlist_title === 'string'
      || artlist?.artlist_image?.image_id
      || typeof artlist?.artlist_artworks_total === 'number'
      || Array.isArray(artlist?.artlist_artworks)
      || artlist?.artlist_creator?.user_username
    )
  );
}

export function hasRenderablePost(post) {
  return Boolean(post?._id && post?.post_container);
}

export function hasRenderableThought(thought) {
  return hasRenderableArtworkReference(thought?.thought_artwork);
}

export function hasRenderableRating(rating) {
  return hasRenderableArtworkReference(rating?.rating_artwork);
}

export function filterRenderableThoughts(thoughts = []) {
  return thoughts.filter(hasRenderableThought);
}

export function filterRenderableRatings(ratings = []) {
  return ratings.filter(hasRenderableRating);
}

export function filterRenderableArtworkGridItems(artworks = []) {
  return artworks.filter(hasRenderableArtworkGridItem);
}

export function filterRenderableArtlists(artlists = []) {
  return artlists.filter(hasRenderableArtlist);
}

export function filterRenderablePosts(posts = []) {
  return posts.filter(hasRenderablePost);
}
